import { Keyboard, Pagination } from "swiper/modules";

import { MobileVersion } from "../styles/ProductsStyles";
import type { ProductProps } from "./ProductsTypes";
import ProductsSwiper from "./ProductsSwiper";
import { useProductDetailsClick } from "./useProductDetailsClick";
import { useSwiperPagination } from "./useSwiperPagination";

export function ProductsMobile({
  products,
  navigate,
  navigateOut,
}: Readonly<ProductProps>) {
  const pagination = useSwiperPagination();
  const handleProductDetailsClick = useProductDetailsClick(navigate);

  return (
    <MobileVersion container>
      <ProductsSwiper
        products={products}
        navigateOut={navigateOut}
        gtmHandleClick={handleProductDetailsClick}
        grabCursor
        keyboard
        pagination={pagination}
        modules={[Pagination, Keyboard]}
      />
    </MobileVersion>
  );
}

export default ProductsMobile;